import React, { useState } from 'react';
import { Input } from '@naf/input';
import * as S from './InsuranceCalculator.styles';

export const InsuranceCalculatorBlock = () => {
  const [registrationNumber, setRegistrationNumber] = useState('');

  const onSubmit = () => {
    if (typeof window !== 'undefined') {
      window.location.href = `https://www.gjensidige.no/tariffering-web/open/dispatcher/naf/bil?utm_id=8z6o&utm_source=naf&utm_medium=affiliate&utm_campaign=naf-nettsider_beregn-pris-p%C3%A5-bilforsikring&regnr=${registrationNumber}&x-client-id=naf `;
    }
  };

  return (
    <S.Wrapper>
      <S.StyledLabel htmlFor="insurance-calculator-input">Registreringsnummer</S.StyledLabel>
      <Input
        onChange={setRegistrationNumber}
        onKeyPress={(e: KeyboardEvent) => {
          if (e.key === 'Enter') {
            onSubmit();
          }
        }}
        placeholder="Registreringsnummer"
        id="insurance-calculator-input"
      />
      <S.StyledButton onClick={onSubmit}>Beregn pris på forsikring</S.StyledButton>
    </S.Wrapper>
  );
};
